import React, { useState, useEffect } from "react";
import * as styles from "./SearchBar.module.scss";
import Lupa from "../../../icons/searchs/lupa.svg";
import LupaBlack from "../../../icons/searchs/lupaBlack.svg";
import { Search } from "../../../services/Search/Search";
import { navigate } from "gatsby";
// Importa el icono de cierre si decides usar un SVG
// import CloseIcon from "../../../icons/close.svg";

const SearchBar = ({ color }) => {
  const [SearchBarOpen, setSearchBarOpen] = useState(false);
  const [lupaPosition, setLupaPosition] = useState(0);
  const [countryOn, setCountryOn] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const open = () => {
    setSearchBarOpen(!SearchBarOpen);
    setLupaPosition(SearchBarOpen ? 0 : -170);
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const countryFromLocalStorage = localStorage.getItem("country");
      setCountryOn(countryFromLocalStorage);
    }
  }, []);

  const handleSearch = async (event) => {
    event.preventDefault();
    try {
      const response = await Search(countryOn, searchValue);
      navigate("/resultado-de-busqueda", { state: { results: response } });
    } catch (error) {
      console.error("Error al realizar la búsqueda:", error);
    }
  };

  const handleClose = () => {
    setSearchBarOpen(false);
    setLupaPosition(0);
  };

  return (
    <div className={`${styles.container} `}>
      {SearchBarOpen && (
        <form onSubmit={handleSearch}>
          <input
            type="search"
            className={`${color === "black" ? styles.inputBlack : styles.input}`}
            placeholder="Buscar..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />

          <button type="submit" style={{ display: "none" }}>
            Buscar...
          </button>
        </form>
      )}

      {color === "black" ? (
        <img
          className={styles.lupa}
          onClick={open}
          src={LupaBlack}
          alt="Lupa negra"
          style={{ "--lupa-position": `${lupaPosition}px` }}
        />
      ) : (
        <img
          className={styles.lupa}
          onClick={open}
          src={Lupa}
          alt="Lupa"
          style={{ "--lupa-position": `${lupaPosition}px` }}
        />
      )}
    </div>
  );
};

export default SearchBar;
